import { useEffect } from 'react';
import { SET_THE_REALM, SET_THE_TOKEN } from "../app/start/actions";
import connect from '../shared/connectWithOnLoad';

// ─── Store-Komponente ────────────────────────────────────────────────────────
// Stellt sicher, dass Realm/Token beim Start aus dem sessionStorage wiederhergestellt
// und nach Redux gespiegelt werden. Alle Werte selbst liegen in Redux (theRealm, keycloakToken).

const Store = ({ children, theRealm, setTheRealm, keycloakToken, setKeycloakToken }) => {
    // Session-Restore
    const myToken = sessionStorage.getItem('kctoken');
    if (myToken && myToken !== 'undefined') {
        keycloakToken = myToken;
    }
    if (theRealm === '' && sessionStorage.getItem('realm_stuff')) {
        theRealm = sessionStorage.getItem('realm_stuff');
        setTheRealm(theRealm);
    }

    useEffect(() => {
        setKeycloakToken(keycloakToken);
    }, [keycloakToken, setKeycloakToken]);

    return children;
};

function mapStateToProps({ theRealm, keycloakToken }) {
    return { theRealm, keycloakToken };
}

function mapDispatchToProps(dispatch) {
    return {
        setTheRealm(theRealm) {
            dispatch({ type: SET_THE_REALM, action: theRealm });
        },
        setKeycloakToken(keycloakToken) {
            dispatch({ type: SET_THE_TOKEN, action: keycloakToken });
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Store);
